import LocalConfigContext from "components/context/LocalConfigContext";
import { useCallback, useContext, useEffect } from "react";
import { usePostSeedTransactionMutation } from "store/api/apiSlice";
import { CardNetwork } from "types/cardNetwork";

const useKeyboardShortcuts = () => {
  const config = useContext(LocalConfigContext);
  const [postSeedTransaction] = usePostSeedTransactionMutation();

  const handleKeyUp = useCallback(
    (event: KeyboardEvent) => {
      if (event.altKey) {
        const action = (() => {
          switch (event.code) {
            case "Digit4":
              return config.toggleLastFour;
            case "KeyC":
              return config.toggleCashflowConfigLink;
            case "KeyT":
              return postSeedTransaction;
            case "KeyM":
              return () => config.updateCardNetwork(CardNetwork.mastercard);
            case "KeyV":
              return () => config.updateCardNetwork(CardNetwork.visa);
            default:
              return null;
          }
        })();

        if (action) {
          event.preventDefault();
          action();
        }
      }
    },
    [config.toggleLastFour, config.toggleCashflowConfigLink]
  );

  useEffect(() => {
    window.addEventListener("keyup", handleKeyUp);

    return () => {
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, [handleKeyUp]);

  return null;
};

export default useKeyboardShortcuts;
